import { useEffect, useState } from "react";

import logger from "~/helpers/logger";
import resolvePortalPathTenantId, { normalizeCompanySlugCandidate } from "~portal/helpers/resolvePortalPathTenantId";
import fetchTenantIdByCompanySlug from "~portal/helpers/vanityTenantApi";

export type PortalPathTenantResolution = { status: "loading" } | { status: "resolved"; tenantId: string };

const usePortalPathTenantResolution = (rawSlug: string): PortalPathTenantResolution => {
	const [resolution, setResolution] = useState<PortalPathTenantResolution>({ status: "loading" });

	useEffect(() => {
		let isCurrent = true;
		const lookupSlug = normalizeCompanySlugCandidate(rawSlug);

		if (!lookupSlug) {
			setResolution({ status: "resolved", tenantId: resolvePortalPathTenantId(rawSlug, null) });
			return;
		}

		setResolution({ status: "loading" });
		(async () => {
			let companySlugTenantId: string | null = null;
			try {
				companySlugTenantId = await fetchTenantIdByCompanySlug(lookupSlug);
			} catch (resolveErrorCause) {
				logger.error(
					"Failed to resolve path-based portal tenant slug; falling back to the raw path segment",
					resolveErrorCause
				);
			}
			if (!isCurrent) return;
			setResolution({ status: "resolved", tenantId: resolvePortalPathTenantId(rawSlug, companySlugTenantId) });
		})();
		return () => {
			isCurrent = false;
		};
	}, [rawSlug]);

	return resolution;
};

export default usePortalPathTenantResolution;
